//
//
//
export default {
  head() {
    return {
      meta: [
        // 受保护页面禁止搜索引擎索引
        ...(this.$route.meta?.protected
          ? [{ name: 'robots', content: 'noindex, nofollow, noarchive' }]
          : [])
      ]
    }
  }
}
